export class InsuranceNumberService {
  public static isNumberOfInsured(suspectedNumber: string): boolean {
    const charToCompare = suspectedNumber.charAt(0);
    const isLeadingCharValid = charToCompare >= 'A' && charToCompare <= 'Z';

    if (!isLeadingCharValid) {
      return false;
    }

    const leadingCharValue = charToCompare.charCodeAt(0) - 64;

    let concatedString: string;
    if (leadingCharValue < 10) {
      concatedString = '0' + leadingCharValue + suspectedNumber.substr(1);
    } else {
      concatedString = leadingCharValue + suspectedNumber.substr(1);
    }

    if (concatedString.length !== 11) {
      return false;
    }

    let sum = 0;

    for (let i = 0; i < 10; i++) {
      const mult = (i % 2) + 1;

      let res = Number.parseInt(concatedString.charAt(i), 10) * mult;

      if (res > 9) {
        const resArray = res.toString().split('');
        res = Number.parseInt(resArray[0], 10) + Number.parseInt(resArray[1], 10);
      }

      sum += res;
    }

    const controlNumber = sum % 10;

    return controlNumber === Number.parseInt(concatedString.charAt(10), 10);
  }

  public static tryExtractingInstitutionCode(suspectedBock: string): string | null {
    if (suspectedBock.length < 9) {
      return null;
    }
    if (this.isValidInstitutionCode(suspectedBock)) {
      return suspectedBock;
    }
    // check if the institution id is part of the block
    const start = suspectedBock.slice(0, 9);
    if (isNaN(parseInt(suspectedBock[9])) && this.isValidInstitutionCode(start)) {
      return start;
    }
    const end = suspectedBock.slice(-9);
    if (isNaN(parseInt(suspectedBock[suspectedBock.length - 10])) && this.isValidInstitutionCode(end)) {
      return end;
    }
    // the format on the backside of the German card is [number - name] (e.g. '101520078 - MOBIL KK')
    const detectedNumbers = suspectedBock.match(/\D(\d{9}) - /)?.map(number => number.slice(0, 9));
    if (detectedNumbers == null) {
      return null;
    }
    for (const detectedNumber of detectedNumbers) {
      if (this.isValidInstitutionCode(detectedNumber)) {
        return detectedNumber;
      }
    }
    return null;
  }

  public static isValidInstitutionCode(suspectedNumber: string): boolean {
    if (/^\d{9}$/.test(suspectedNumber) === false) {
      return false;
    }
    return this.isInstitutionCodeChecksumValid(suspectedNumber);
  }

  private static isInstitutionCodeChecksumValid(ikNumber: string): boolean {
    // classification (first digits) are not error checked
    // the last digit is the checksum
    const checksum = Number.parseInt(ikNumber.charAt(8), 10);
    const ikNumberWithoutControl = ikNumber.slice(2, 8);

    let weightedSum = 0;
    for (let i = 0; i < 6; i++) {
      const isEven = i % 2 === 0;
      const multiplicator = isEven ? 2 : 1;
      const digit = Number.parseInt(ikNumberWithoutControl.charAt(i), 10);
      let weightedDigit = digit * multiplicator;
      if (weightedDigit > 9) {
        weightedDigit = weightedDigit - 9;
      }
      weightedSum += weightedDigit;
    }
    return weightedSum % 10 === checksum;
  }
}
